import type { Review } from '../types/product';
export const featuredReview: Review = {
  initials: 'MP',
  name: 'María P.',
  role: 'Operatrice olistica',
  location: 'Uruguay',
  accent: 'rose',
  text: 'Per la prima volta ho un sistema completo per i miei incontri. I miei clienti percepiscono la differenza fin dall’inizio e, quando spiego quali fiori ho scelto e perché, sentono di essere nelle mani di una vera professionista.'
};
export const reviews: Review[] = [{
  initials: 'MV',
  name: 'María V.',
  role: 'Operatrice olistica',
  location: 'Mendoza, Argentina',
  accent: 'rose',
  text: 'Per la prima volta ho un sistema completo per i miei incontri. I miei clienti percepiscono la differenza fin dall’inizio e, quando spiego quali fiori ho scelto e perché, sentono di essere nelle mani di una vera professionista.'
}, {
  initials: 'CL',
  name: 'Carolina L.',
  role: "Operatrice energetica",
  location: "Cile",
  accent: 'violet',
  text: 'Lo Scudo dell’Operatore, da solo, vale l’intero pack. Prima tornavo a casa esausta senza capire perché. Ora, con le tecniche di protezione, la differenza è enorme.'
}, {
  initials: 'SM',
  name: 'Sofía M.',
  role: 'Operatrice in formazione',
  location: 'Colombia',
  accent: 'amber',
  text: 'Avevo appena iniziato e il kit mi ha dato la struttura di cui avevo bisogno fin dal primo incontro. Sono arrivata in studio con un criterio, dal primo giorno.'
}];